"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryOperation = void 0;
const and_operation_1 = require("../../../../#lib/expression-tree/nodes/and-operation");
const equal_operation_1 = require("../../../../#lib/expression-tree/nodes/equal-operation");
const greater_than_operation_1 = require("../../../../#lib/expression-tree/nodes/greater-than-operation");
const greater_than_or_equal_operation_1 = require("../../../../#lib/expression-tree/nodes/greater-than-or-equal-operation");
const less_than_operation_1 = require("../../../../#lib/expression-tree/nodes/less-than-operation");
const less_than_or_equal_operation_1 = require("../../../../#lib/expression-tree/nodes/less-than-or-equal-operation");
const match_operation_1 = require("../../../../#lib/expression-tree/nodes/match-operation");
const not_equal_operation_1 = require("../../../../#lib/expression-tree/nodes/not-equal-operation");
const not_match_operation_1 = require("../../../../#lib/expression-tree/nodes/not-match-operation");
const not_subset_operation_1 = require("../../../../#lib/expression-tree/nodes/not-subset-operation");
const not_superset_operation_1 = require("../../../../#lib/expression-tree/nodes/not-superset-operation");
const or_operation_1 = require("../../../../#lib/expression-tree/nodes/or-operation");
const subset_operation_1 = require("../../../../#lib/expression-tree/nodes/subset-operation");
const superset_operation_1 = require("../../../../#lib/expression-tree/nodes/superset-operation");
const syntax_exception_1 = require("../syntax-exception");
const syntax_kind_1 = require("../syntax-kind");
const ast_node_1 = require("./ast-node");
class BinaryOperation extends ast_node_1.AstNode {
    constructor(kind, leftOperand, rightOperand) {
        super(kind);
        this.leftOperand = leftOperand;
        this.rightOperand = rightOperand;
    }
    get children() {
        return [this.leftOperand, this.rightOperand];
    }
    toExpressionTreeNode() {
        const left = this.leftOperand.toExpressionTreeNode();
        const right = this.rightOperand.toExpressionTreeNode();
        switch (this.kind) {
            case syntax_kind_1.SyntaxKind.OrOperation:
                return new or_operation_1.OrOperation(left, right);
            case syntax_kind_1.SyntaxKind.AndOperation:
                return new and_operation_1.AndOperation(left, right);
            case syntax_kind_1.SyntaxKind.EqualOperation:
                return new equal_operation_1.EqualOperation(left, right);
            case syntax_kind_1.SyntaxKind.NotEqualOperation:
                return new not_equal_operation_1.NotEqualOperation(left, right);
            case syntax_kind_1.SyntaxKind.GreaterThanOperation:
                return new greater_than_operation_1.GreaterThanOperation(left, right);
            case syntax_kind_1.SyntaxKind.GreaterThanOrEqualOperation:
                return new greater_than_or_equal_operation_1.GreaterThanOrEqualOperation(left, right);
            case syntax_kind_1.SyntaxKind.LessThanOperation:
                return new less_than_operation_1.LessThanOperation(left, right);
            case syntax_kind_1.SyntaxKind.LessThanOrEqualOperation:
                return new less_than_or_equal_operation_1.LessThanOrEqualOperation(left, right);
            case syntax_kind_1.SyntaxKind.MatchOperation:
                return new match_operation_1.MatchOperation(left, right);
            case syntax_kind_1.SyntaxKind.NotMatchOperation:
                return new not_match_operation_1.NotMatchOperation(left, right);
            case syntax_kind_1.SyntaxKind.SubsetOperation:
                return new subset_operation_1.SubsetOperation(left, right);
            case syntax_kind_1.SyntaxKind.NotSubsetOperation:
                return new not_subset_operation_1.NotSubsetOperation(left, right);
            case syntax_kind_1.SyntaxKind.SupersetOperation:
                return new superset_operation_1.SupersetOperation(left, right);
            case syntax_kind_1.SyntaxKind.NotSupersetOperation:
                return new not_superset_operation_1.NotSupersetOperation(left, right);
            default:
                throw new syntax_exception_1.SyntaxException();
        }
    }
}
exports.BinaryOperation = BinaryOperation;
//# sourceMappingURL=binary-operation.js.map